<script setup>
import { ToastContainer } from '@bpmlib/vue-satoast';
</script>

<template>
  <RouterView />
  <ToastContainer />
</template>

<style scoped>
</style>
